import {get} from 'lodash';
import {boxStyles} from '../Box/BoxStyles';

// @ts-expect-error - TS7031 - Binding element 'color' implicitly has an 'any' type. | TS7031 - Binding element 'theme' implicitly has an 'any' type.
function getColor({color, theme}) {
  if (!color) return undefined;
  if (typeof color !== 'string') return undefined;

  return get(theme.colors, color) || color;
}

export const textStyles = (props: any) => {
  const {theme, textColor, style = {}} = props;

  return {
    ...boxStyles(props),
    color: getColor({color: textColor, theme}),
    ...style,
  };
};
